import { render, staticRenderFns } from "./OtherManage.vue?vue&type=template&id=43bfcd65&scoped=true&"
import script from "./OtherManage.vue?vue&type=script&lang=js&"
export * from "./OtherManage.vue?vue&type=script&lang=js&"
import style0 from "./OtherManage.vue?vue&type=style&index=0&id=43bfcd65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bfcd65",
  null
  
)

export default component.exports